import React from 'react';
import cn from 'classnames';
import styles from './integration_buttons.module.less';
import {Select} from '../../../../shared/ui/select';
import Chevron_down from '../../img/icons/16/chevron_down.svg';

interface i_integration_buttons_props {
    oculus?: boolean;
    active_category: string;
    groups: {value: string; label: string}[];
    on_category_change: (category: string) => void;
}

export const Integration_buttons = (props: i_integration_buttons_props)=>{
    const {groups, active_category, on_category_change, oculus} = props;
    return <div className={cn(styles.groups, {[styles.oculus_group]: oculus})}>
      <Select
        default_value={active_category}
        cls={styles.select_container}
        dropdown_icon={!oculus && <Chevron_down />}
        placeholder=""
        options={groups}
        on_change={value=>
        on_category_change(String(value))}
        render_option={option_props=>
          <div className={styles.select_item}>
          {option_props.option.label}</div>}
      />
      <div className={styles.groups_buttons}>
        {groups.map(({value, label})=>
          <button
            key={value}
            className={cn(styles.groups_btn,
              active_category===value && styles.active)}
            onClick={()=>on_category_change(value)}
          >{label}</button>
        )}
      </div>
    </div>;
};
